/**
 * Environment utility constants
 * Evaluated from compile-time env values exposed by Vite.
 */

export const environment: string = import.meta.env.VITE_STAGE;

export const isProduction: boolean = environment === 'prod';

export const isStage: boolean = environment === 'stage';

export const isDevelopment: boolean = ['dev', 'feature'].includes(environment);

export const isLocalhost: boolean = window.location.hostname === 'localhost';
